import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
const useLanguage = () => {
    const { i18n } = useTranslation();

    useEffect(() => {
        const language = localStorage.getItem("language") || "en";
        i18n.changeLanguage(language);
    }, [i18n]);
};

export default useLanguage;